<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <h3 class="headline mb-0">Zahlstatus</h3>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs8>Kategorie: {{ category.title }}</v-flex>
      <v-flex xs2 class="text-xs-right">{{ priceCategory.toFixed(2) }} €</v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs8>Gesamtpreis:</v-flex>
      <v-flex xs2 class="text-xs-right"><b class="red--text">{{ priceTotal.toFixed(2) }} €</b></v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout :key="item.id" row v-for="item in participant.payments" wrap align-center>
      <v-flex xs8>
        Einnahme vom {{ item.date }} ({{ parsePaymentSource(item.source) }})
      </v-flex>
      <v-flex xs2 class="text-xs-right"><b class="green--text">{{ item.amount.toFixed(2) }} €</b></v-flex>
      <v-flex xs2>
        <v-btn small @click="deletePayment(item)" icon>
          <v-icon color="red" small>fal fa-trash</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout row wrap>
      <v-flex xs8>Kontostand:</v-flex>
      <v-flex xs2 class="text-xs-right"><b :class="balance >= 0 ? 'green--text' : 'red--text'">{{ balance.toFixed(2) }} €</b></v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-layout row wrap align-center>
      <v-flex xs5>
        <v-text-field
            label="Datum"
            mask="##.##.####" prepend-icon="fal fa-calendar" v-model="payment.date"></v-text-field>
      </v-flex>
      <v-flex xs5>
        <v-text-field
            label="Betrag"
            prepend-icon="fal fa-euro-sign" v-model="payment.amount"></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-btn @click="addPayment()" color="primary" flat icon>
          <v-icon>fal fa-check</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-snackbar :value="snackbarSaved" bottom right color="success">
      Zahlung wurde gespeichert.
      <v-btn flat @click="snackbarSaved = false">
        <v-icon>fal fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import PaymentService from "../services/PaymentService";

  export default {
    name: 'Payment',
    components: {},
    props: {
      participant: {
        type: Object,
        default: function () {
          return {
            id: null,
            category: null,
            payments: [],
            price: 0
          }
        }
      }
    },
    computed: {
      category() {
        let category
        if (this.participant !== undefined && this.participant.category !== undefined) {
          category =  this.$store.state.categories.find(category => this.participant.category === category.id)
          if (category !== undefined) {
            return category
          }
        }
        return {
          title: '',
          price: 0
        }
      },
      priceTotal() {
        if (this.participant !== undefined) {
          return this.participant.price
        }

        return 0
      },
      priceCategory() {
        if (this.participant !== undefined) {
          return this.participant.price
        }

        return 0
      },
      balance() {
        let payments = 0
        if (this.participant !== undefined) {
          this.participant.payments.map(payment => {
            payments += payment.amount
          })
        }

        return -this.priceTotal + payments
      }
    },
    methods: {
      parsePaymentSource: function (value) {
        if (value === 'remittance') return 'Überweisung'
        if (value === 'paypal') return 'PayPal'
      },
      addPayment: function () {
        this.payment.participantId = this.participant.id
        PaymentService.add(this.payment).then(resp => {
          if (resp.status === 200) {
            this.snackbarSaved = true
            this.payment.amount = null
            this.payment.date = null
            this.$store.dispatch('loadParticipant', this.participant.id)
          }
        })
      },
      deletePayment: function (payment) {
        PaymentService.delete(payment).then(resp => {
          if (resp.status === 204) {
            this.snackbarSaved = true
            this.$store.dispatch('loadParticipant', this.participant.id)
          }
        })
      }
    },
    data: function () {
      return {
        snackbarSaved: false,
        payment: {
          date: '',
          amount: null,
          participantId: null
        }
      }
    }
  }
</script>
